function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersDisplay = /*#__PURE__*/function () {
  function SettlersDisplay() {
    _classCallCheck(this, SettlersDisplay);
  }
  return _createClass(SettlersDisplay, [{
    key: "displayBoard",
    value: function displayBoard() {
      try {
        console.log('Display board');
        $('.road.empty').remove();
        for (var i in this.game.state.hexes) {
          var divname = '#hex_bg_' + i;
          $(divname).html("<img class=\"hex_img2\" src=\"".concat(this.game.state.hexes[i].img, "\">"));
          if (this.game.state.hexes[i].resource != this.returnNullResource()) {
            var svid = this.addSectorValueToGameboard(i, this.game.state.hexes[i].value);
            if (this.game.state.hexes[i].robber) document.getElementById(svid).classList.add('bandit');
          }
        }
        for (var _i in this.game.state.cities) {
          var _divname = '#' + this.game.state.cities[_i].slot;
          var classname = 'p' + this.game.colors[this.game.state.cities[_i].player - 1];
          $(_divname).addClass(classname);
          $(_divname).removeClass('empty');
          if (this.game.state.cities[_i].level == 1) {
            $(_divname).html(this.c1.svg);
          } else {
            /* == 2*/
            $(_divname).html(this.c2.svg);
          }
          $(_divname).addClass(classname);
          var ad = this.returnAdjacentCitySlots(this.game.state.cities[_i].slot);
          for (var _i2 = 0; _i2 < ad.length; _i2++) {
            var d = '#' + ad[_i2];
            try {
              $(d).remove();
            } catch (err) {
              console.error(err);
            }
          }
        }
        for (var _i3 in this.game.state.roads) {
          //Not the most efficient, but should work to both draw the built roads and prep the available spaces for future building
          this.buildRoad(this.game.state.roads[_i3].player, this.game.state.roads[_i3].slot);
        }
        this.displayPlayers();
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "displayScore",
    value: function displayScore() {
      var queueLength = this.game.queue.length;
      this.updateScore();
      if (!this.browser_active) return;
      for (var i = 0; i < this.game.state.players.length; i++) {
        if (this.racetrack.players[i]) this.racetrack.players[i].score = this.game.state.players[i].vp;
      }
      this.racetrack.render();
      this.racetrack.lock();
      $('.main').toggleClass('robinhood', !!this.game.state.robinhood);
      if (this.game.state.robinhood && !this.game.state.robinhood_overlay) {
        this.game.state.robinhood_overlay = 1;
        this.game_help.render({
          title: 'Robin Hood',
          text: 'Robin Hood is a friendly bandit (in 1v1 games) that helps the losing player, who will be immune to Robin Hood raiding their hand or blocking their resource production',
          img: '/settlers/img/robinhood_background.jpg',
          line1: 'who is',
          line2: 'robin hood?',
          id: 'robinhood',
          fontsize: '2.1rem',
          color: '#1a7004',
          duration: 5000
        });
      }
      if (this.game.queue.length > queueLength && this.game.queue.at(-1).startsWith('roll_bandit')) {
        this.card_overlay.render({
          player: this.game.state.robinhood,
          card: 'Robin Hood'
        });
      }
    }
  }, {
    key: "displayCardfan",
    value: function displayCardfan() {
      var deck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.gameBrowserActive()) {
        return;
      }
      try {
        var cards = '';
        var resources = this.game.state.players[this.game.player - 1].resources;
        var _iterator = _createForOfIteratorHelper(resources),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var r = _step.value;
            cards += "<div class=\"card\" data-resource=\"".concat(r, "\">\n                    <img src=\"").concat(this.returnCardImage(r), "\">\n                  </div>");
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (cards) {
          this.cardfan.render(cards);
        } else {
          this.cardfan.hide();
        }
      } catch (err) {
        console.error(err);
      }
    }

    // Only for the game Observer
  }, {
    key: "showPlayerResources",
    value: function showPlayerResources() {
      try {
        $('.player-box-graphic .hand').remove();
        for (var i = 0; i < this.game.players.length; i++) {
          var hand = "<div class=\"hand\">";
          var _iterator2 = _createForOfIteratorHelper(this.game.state.players[i].resources),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var r = _step2.value;
              hand += "<div class=\"card\">\n                  <img src=\"".concat(this.returnCardImage(r), "\">\n                  <img class=\"icon\" src=\"").concat(this.returnCardImage(r), "\"/>\n                </div>");
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          hand += '</div>';
          this.playerbox.appendGraphic(hand, i + 1);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "formatPlayer",
    value: function formatPlayer(playerNumber) {
      return "<span class=\"p".concat(this.game.colors[playerNumber - 1], "-lite display-name\">").concat(this.game.playerNames[playerNumber - 1], "</span>");
    }
  }, {
    key: "formatResource",
    value: function formatResource(resource) {
      return "<div class=\"card tiny\"><img src=\"".concat(this.returnCardImage(resource), "\" /></div>");
    }
  }, {
    key: "displayPlayers",
    value: function displayPlayers() {
      var _this = this;
      this.displayScore();
      if (!this.browser_active) {
        return;
      }
      console.log('Display players');
      var card_dir = '/settlers/img/cards/';
      var _loop = function _loop(i) {
        //
        // PLAYERBOX HEAD - graphics box
        //
        var statshtml = "<div class=\"token\">";
        if (_this.game.state.players[i - 1].vpc > 0) {
          //Victory Point Card Tokens -- should move to VP track
          for (var j = 0; j < _this.game.state.players[i - 1].vpc; j++) {
            statshtml += "<div class=\"victory_point_card\">".concat(_this.vp.img, "</div>");
          }
          statshtml += "<div class=\"vproundel\" title=\"victory point card\">".concat(_this.game.state.players[i - 1].vpc, "</div>");
        }
        for (var _j = 0; _j < _this.game.state.players[i - 1].knights; _j++) {
          statshtml += _this.s.img;
        }
        if (_this.game.state.largestArmy.player == i) {
          statshtml += "<div class=\"vproundel\" title=\"".concat(_this.largest.name, "\">").concat(_this.largest.value, "</div>");
        }
        if (_this.game.state.longestRoad.player == i) {
          statshtml += "  <div class=\"gap-token\"></div>\n                        ".concat(_this.longest.icon, "\n                        <div class=\"vproundel\" title=\"").concat(_this.longest.name, "\">").concat(_this.longest.value, "</div>");
        }

        //
        // PLAYERBOX HEAD
        //
        _this.game.state.players[i - 1].resources.sort();
        var num_resources = _this.game.state.players[i - 1].resources.length;
        var num_cards = _this.game.state.players[i - 1].devcards.length;
        if (i == _this.game.player) {
          num_cards += _this.game.deck[0].hand.length;
        }
        var icons = '';
        if (num_resources) {
          icons += "<div class=\"cardct resource-cards\">\n                    <img src=\"".concat(_this.back, "\"/>\n                    <div>").concat(num_resources, "</div>\n                  </div>");
        }
        if (num_cards) {
          icons += "<div class=\"cardct dev-cards\">\n                    ".concat(_this.vp.img, "\n                    <div>").concat(num_cards, "</div>\n                  </div>");
        }
        _this.playerbox.updateIcons(icons, i);

        //
        // PLAYERBOX BODY
        //
        _this.playerbox.updateBody(statshtml, i);
        if (!_this.game.over) {
          if (_this.game.state.ads[i - 1].offer || _this.game.state.ads[i - 1].ask) {
            var offer = _this.wishListToImage(_this.game.state.ads[i - 1].offer);
            var ask = _this.wishListToImage(_this.game.state.ads[i - 1].ask);
            var id = "trade_".concat(i);
            var html = "<div class=\"trade\" id=\"".concat(id, "\">\n            <img src=\"").concat(_this.back, "\"/>\n            <i class=\"fa-solid fa-money-bill-transfer\"></i>\n            </div>\n            ");
            _this.playerbox.updateGraphics(html, i);
            id = '#' + id;
            var settlers_self = _this;
            $(id).off();
            $(id).on('click', function () {
              //  Launch overlay window for private trade
              settlers_self.showTradeOverlay(i, settlers_self.game.state.ads[i - 1].ask, settlers_self.game.state.ads[i - 1].offer);
            });
          } else {
            //this.playerbox.updateGraphics('', i);
          }
        }
      };
      for (var i = 1; i <= this.game.state.players.length; i++) {
        _loop(i);
      }
      if (this.game.deck[0].hand.length == 0 && this.game.state.players[this.game.player - 1].devcards.length == 0) {
        $('#settlers-hud-controls #playcard').removeClass('enabled');
      }
      if (this.game.player == 0) {
        this.showPlayerResources();
        return;
      }

      //Show player cards and add events (Doesn't need to be in for loop!)
      this.displayCardfan();
    }

    /*<><><><><><><>
    Broadcast offer to trade to all players
    This just makes an advertisement accessible through game menu to any player at any time (even if not eligible to trade)
    and there is no game mechanic to go directly into accepting or rejecting the trade
    @param tradeType (integer) the player number of the targeted player, 0 for all players, -1 for advertisement
    */
  }, {
    key: "showTradeOverlay",
    value: function showTradeOverlay() {
      var offering_player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var i_should_give = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i_should_accept = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (offering_player) {
        this.trade_overlay.offering_player = offering_player;
      }
      if (i_should_give || i_should_accept) {
        i_should_give = i_should_give || {};
        i_should_accept = i_should_accept || {};
        if (this.game.player === offering_player) {
          this.trade_overlay.get = i_should_give;
          this.trade_overlay.give = i_should_accept;
          this.trade_overlay.accepting_trade = 0;
        } else {
          this.trade_overlay.get = i_should_accept;
          this.trade_overlay.give = i_should_give;
          this.trade_overlay.accepting_trade = 1;
        }
        console.log('Consider trade offer');
        console.log(i_should_give, i_should_accept);
        this.trade_overlay.render(false); // don't reset, we want to start with this trade
      } else {
        this.trade_overlay.render();
      }
    }

    /***********
     *
     * Game animations
     *
     ***********/
  }, {
    key: "animateHarvest",
    value: function animateHarvest(player, resource) {
      var _this2 = this;
      var tile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (this.app.HEADLESS) return;
      var destination;
      if (player == this.game.player) {
        if (document.getElementById('cardfan')) {
          destination = '#cardfan';
        } else {
          destination = '#hud';
        }
      } else {
        destination = '#game-playerbox-' + player;
      }
      if (tile) {
        tile = '#sector_value_' + tile;
      }
      this.animationSequence.push({
        callback: this.moveGameElement,
        params: [this.createGameElement("<div class=\"card_holder\"><img src=\"".concat(this.returnCardImage(resource), "\"/></div>"), tile, tile), destination, null, function () {
          $('.animated_elem').remove();
          _this2.restartQueue();
        }]
      });
    }
  }, {
    key: "animateDevCard",
    value: function animateDevCard(player) {
      var _this3 = this;
      if (this.app.HEADLESS) return;
      var destination = '#game-playerbox-' + player;
      if (player == this.game.player) {
        var elm = this.createGameElement("<div class=\"card_holder\"><img src=\"".concat(this.card.back, "\"/></div>"), '#game-hexgrid', '.hex.dummy');
        this.moveGameElement(elm, destination);
      } else {
        this.animationSequence.push({
          callback: this.moveGameElement,
          params: [this.createGameElement("<div class=\"card_holder\"><img src=\"".concat(this.card.back, "\"/></div>"), '#game-hexgrid', '.hex.dummy'), destination, null, function () {
            $('.animated_elem').remove();
            _this3.restartQueue();
          }]
        });
        this.runAnimationQueue(250);
      }
    }

    /*
    Briefly animate the longest road and update log if there is a change in ownership
    */
  }, {
    key: "highlightRoad",
    value: function highlightRoad(player, road, msg) {
      if (this.app.HEADLESS) return;
      this.updateLog("".concat(this.formatPlayer(player), " ").concat(msg));
      var _iterator3 = _createForOfIteratorHelper(road),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var segment = _step3.value;
          var selector = '#road_' + segment;
          var div = document.querySelector(selector);
          if (div) div.classList.add('roadhighlight');
          //else  console.log("Null selector?",selector);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var divname = '.roadhighlight';
      $(divname).css('background', '#FFF').delay(500).queue(function () {
        $(this).removeAttr('style').dequeue();
      }).delay(500).queue(function () {
        $(this).css('background', '#FFF').dequeue();
      }).delay(500).queue(function () {
        $(this).removeAttr('style').dequeue();
      }).delay(500).queue(function () {
        $(this).css('background', '#FFF').dequeue();
      }).delay(500).queue(function () {
        $(this).removeAttr('style').dequeue();
      }).delay(500).queue(function () {
        $(this).css('background', '#FFF').dequeue();
      }).delay(500).queue(function () {
        $(this).removeAttr('style').removeClass('roadhighlight').dequeue();
      });
    }

    /*
    Flashes tiles activated by dice roll
    */
  }, {
    key: "animateDiceRoll",
    value: function animateDiceRoll(roll) {
      if (this.app.HEADLESS) return;
      //console.log("Dice Animated: " + roll);
      $('.rolled').removeClass('rolled');
      $('.sector_value:not(.bandit)').attr('style', '');
      var divname = '.sv' + roll + ':not(.bandit)';
      $(divname).css('color', '#000').css('background', '#FFF6').delay(600).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(600).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(600).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(600).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(600).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).addClass('rolled').delay(600).queue(function () {
        $(this).removeAttr('style').dequeue();
      });
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(str) {
      var preserve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      try {
        if (this.lock_interface == 1) {
          return;
        }
        var update = [str, preserve];
        this.game.status = str;
        if (this.status.length > 0) {
          var last = this.status.pop();
          if (last[1]) {
            this.status.push(last);
          }
        }
        this.status.push(update);

        //Keep last three
        while (this.status.length > 3) {
          this.status.shift();
        }
        if (this.game.players.includes(this.publicKey)) {
          if (this.gameBrowserActive()) {
            var complex_str = '';
            var _iterator4 = _createForOfIteratorHelper(this.status),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var ud = _step4.value;
                var s = ud[0];
                if (!s.includes('<div')) {
                  s = "<div class=\"player-notice\">".concat(s, "</div>");
                }
                complex_str += s;
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            this.hud.updateStatus(complex_str);
          }
        }
      } catch (err) {
        console.error('ERR: ' + err);
      }
    }
  }]);
}();
module.exports = SettlersDisplay;